import React, { useState, useEffect } from "react";
import CssTransition from "../../../component/layout/css-transition";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../../redux/actions/user";
import { extendActivityRequest } from "../../../redux/actions/overview";

function EmbeddedExtendActivity({
  modalOpen,
  setModalOpen,
  mappingid,
  activity_id,
  activity_assignment_id,
  company_id,
  email,
}) {
  const [Estimated_date, Set_Estimated_date] = useState("");
  const [remarks, setRemarks] = useState("");
  const [dateError, setDateError] = useState("");
  const [remarkError, setRemarkError] = useState("");

  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);

  const getUser = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Unable to transfer To Do. Please try later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getUserData(request));
  };

  useEffect(() => {
    if (modalOpen) {
      getUser();
    }
  }, [modalOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Estimated_date === "") {
      return setDateError("Please provide extended date for request.");
    }
    if (remarks === "" || remarks.length < 5) {
      return setRemarkError(
        "Please provide atleast 5 characters for send back to admin request."
      );
    }

    const payload = {
      activity_id: activity_id,
      activity_assignment_id: activity_assignment_id,
      assignment_mapping_id: mappingid,
      company_id: company_id,
      request_from:
        userData.filter((item) => item.email === email).length > 0
          ? userData.filter((item) => item.email === email)[0].id
          : "",
      type: "Extend To Do",
      description: remarks,
      extension_period: Estimated_date,
    };

    const request = {
      body: payload,
      onSuccess: (data) => {
        if (typeof data === "string") {
          setModalOpen(false);
          Set_Estimated_date("");
          setDateError("");
          setRemarks("");
          setRemarkError("");
          return swal({
            content: (
              <CustomeModal type="info" title="Information!" content={data} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
        setModalOpen(false);
        Set_Estimated_date("");
        setDateError("");
        setRemarks("");
        setRemarkError("");
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content="Extend To Do request successfully created."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: () => {
        setModalOpen(false);
        Set_Estimated_date("");
        setDateError("");
        setRemarks("");
        setRemarkError("");
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Unable to create extend To Do request. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(extendActivityRequest(request));
  };

  const Clicked_Cancel = () => {
    setModalOpen(false);
    Set_Estimated_date("");
    setDateError("");
    setRemarks("");
    setRemarkError("");
  };

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white overflow-auto max-w-lg w-full max-h-full rounded shadow-lg flex flex-col">
          <div className="py-8 px-6 w-full space-y-3">
            <h3 class="text-lg text-black  leading-6 flex justify-center my-4">
              Extend To Do
            </h3>

            <div className="flex flex-col mb-4 relative">
              <label
                htmlFor="datepicker"
                className="font-inter font-medium text-sm leading-5 text-gray-700 mb-1"
              >
                Estimate Date<sup className="text-rose-500 text-xs">*</sup>
              </label>
              <Flatpickr
                data-enable-time
                options={{
                  enableTime: true,
                  altInput: true,
                  altFormat: "j M, Y H:i",
                  dateFormat: "Y-m-d H:i",
                  time_24hr: true,
                  minDate: "today",
                }}
                placeholder="Select Date"
                value={Estimated_date}
                onChange={(e) => {
                  setDateError("");
                  Set_Estimated_date(e[0]);
                }}
                className="w-full rounded-md border-2 border-gray-200 border-r-4 active:border-gray-200 focus:border-gray-200"
              />
              {dateError !== "" && (
                <div className="text-rose-500 font-inter font-extralight text-xs pt-1">
                  {dateError}
                </div>
              )}
            </div>
            <div className="flex flex-col mb-4 relative">
              <label
                htmlFor="subject"
                className="font-inter font-medium text-sm leading-5 text-gray-700 mb-1"
              >
                Remarks<sup className="text-rose-500 text-xs">*</sup>
              </label>
              <textarea
                rows={5}
                value={remarks}
                onChange={(e) => {
                  setRemarkError("");
                  setRemarks(e.target.value);
                }}
                type="text"
                className="form-input p-2 w-full disabled:border-slate-200 resize-none"
              />
              {remarkError !== "" && (
                <div className="text-rose-500 font-inter font-extralight text-xs pt-1">
                  {remarkError}
                </div>
              )}
            </div>
            <form class="w-full" onSubmit={handleSubmit}>
              <div class="w-full flex justify-end space-x-2">
                <button
                  className="w-full btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 rounded-md text-sm px-5 py-2.5"
                  type="button"
                  onClick={Clicked_Cancel}
                >
                  Cancel
                </button>
                <button
                  className="w-full btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white rounded-md text-sm px-5 py-2.5"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default EmbeddedExtendActivity;
